<template>
    <div>
        <!-- 过滤条件 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 100px; margin-right: 20px"
                v-model="filter.feeType"
                placeholder="费用类型"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in dict.feeType.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 100px; margin-right: 15px"
                v-model="filterBillStatus"
                placeholder="账单状态"
                @on-change="changeFilterBillStatus"
                clearable
            >
                <Option
                    v-for="item in dict.billStatus.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusUser"
                    placeholder="请输入客户姓名"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:billStatusText="{ row }">
                <tag-status
                    v-if="
                        (row.billStatus === '1' || row.billStatus === '3') &&
                        row.overdue > 0
                    "
                    :text="`逾期${row.overdue}天`"
                    color="#EE870D"
                    background="#F9F2E9"
                    circle
                />
                <tag-status
                    v-else
                    :text="row.billStatusText"
                    :color="row.billStatusColor"
                    :background="row.billStatusBgc"
                    circle
                />
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    v-if="$can('view')"
                    >详情</Button
                >
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickRecord(row)"
                    v-if="$can('record')"
                    >修改记录</Button
                >
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showBillForm"
            title="账单详情"
            :width="800"
            :height="600"
            :maskClosable="false"
        >
            <bill-form
                v-if="modal.showBillForm"
                :id="curId"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
                :billStatus="billStatus"
                :actionType="actionType"
            />
        </smart-modal>

        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showBillRecord"
            title="账单修改记录"
            :width="960"
            :height="600"
            :maskClosable="false"
        >
            <bill-record
                v-if="modal.showBillRecord"
                :houseName="houseName"
                :rowId="rowId"
            ></bill-record>
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency, ymd } from '_u/helper'
import { pipeCell, mapCell } from '_c/grid/renderCell'
import dayjs from 'dayjs'
import Dict from '_u/dict'
import {
    getResAmountText,
    renderBillAmountText,
} from '@/views/common/u-contract'
import FilterDateRange from '_v/components/filter/filter-date-range'

import BillForm from '_v/bill/bill-form'
import TagStatus from '_vc/tag-status'
import BillRecord from './bill-record.vue'

import { contractBillListCreate } from '@/api/contract'

export default {
    name: 'cv-bill-list',

    components: { BillForm, TagStatus, BillRecord, FilterDateRange },
    props: {
        contractId: {
            type: [Number, String],
            default: '',
        },
        houseName: {
            tyep: String,
            default: '',
        },
    },

    data() {
        return {
            actionType: '', // 1 新增; 2 查看; 3 修改;
            mtHeight: 360,
            loading: false,
            curId: '',
            page: {
                total: 0,
                list: [],
            },
            billStatus: '', // 账单状态
            filterBillStatus: '', //筛选账单状态
            depositOffset: '', // 定金抵扣方式
            offsetAmount: '', // 定金金额
            modal: {
                showBillForm: false,
                showBillRecord: false,
            },
            dict: {
                feeType: Dict.NULL,
                billStatus: Dict.NULL,
            },
            rowId: '',
        }
    },

    computed: {
        ...mapCache({
            filter: 'contractViewBill',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'feeType',
                    title: '费用类型',
                    align: 'left',
                    minWidth: 120,
                    ellipsis: true,
                    render: mapCell(this.dict.feeType.val()),
                },
                {
                    key: 'cusUser',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'periodText',
                    title: '账期',
                    align: 'center',
                    minWidth: 220,
                },
                {
                    key: 'billStatusText',
                    title: '账单状态',
                    align: 'center',
                    width: 160,
                    slot: 'billStatusText',
                },
                {
                    key: 'receivable',
                    title: '应收金额(元)',
                    align: 'right',
                    minWidth: 160,
                    render: (h, params) => {
                        if (
                            params.row.billStatus === '1' ||
                            params.row.billStatus === '2'
                        ) {
                            const obj = {
                                amount: params.row.planAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        }
                    },
                },
                {
                    key: 'received',
                    title: '已收金额(元)',
                    align: 'right',
                    minWidth: 120,
                    render: (h, params) => {
                        if (params.row.billStatus === '2') {
                            const obj = {
                                amount: params.row.realAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        }
                    },
                },
                {
                    key: 'payable',
                    title: '应付金额(元)',
                    align: 'right',
                    minWidth: 160,
                    render: (h, params) => {
                        if (
                            params.row.billStatus === '3' ||
                            params.row.billStatus === '4'
                        ) {
                            const obj = {
                                amount: params.row.planAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        }
                    },
                },
                {
                    key: 'paid',
                    title: '已付金额(元)',
                    align: 'right',
                    minWidth: 120,
                    render: (h, params) => {
                        if (params.row.billStatus === '4') {
                            const obj = {
                                amount: params.row.realAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        }
                    },
                },
                {
                    key: 'receivableDate',
                    title: '应收款日',
                    align: 'center',
                    minWidth: 110,
                },
                {
                    key: 'receivedDate',
                    title: '已收款时间',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    key: 'payableDate',
                    title: '应付款日',
                    align: 'center',
                    minWidth: 110,
                },
                {
                    key: 'paidDate',
                    title: '已付款时间',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 200,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },
    created() {
        this.filter.contractId = this.contractId || this.filter.contractId
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true
            // this.initBillStatus();

            Promise.all([
                contractBillListCreate(this.filter),
                Dict.get(['fee_type', 'bill_status']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    const billStatusDict = this.dict.billStatus
                    view.data.page.list.forEach((v) => {
                        v.realAmount = currency(v.realAmount / 100)
                        v.planAmount =
                            currency(v.planAmount / 100) + getResAmountText(v)
                        switch (v.billStatus) {
                            case '1':
                                v.receivable = v.planAmount
                                v.receivableDate = v.planDate
                                break
                            case '2':
                                v.receivable = v.planAmount
                                v.receivableDate = v.planDate

                                v.received = v.realAmount
                                v.receivedDate = v.realDate
                                break
                            case '3':
                                v.payable = v.planAmount
                                v.payableDate = v.planDate
                                break
                            case '4':
                                v.payable = v.planAmount
                                v.payableDate = v.planDate

                                v.paid = v.realAmount
                                v.paidDate = v.realDate
                                break
                        }

                        const status = billStatusDict.get(v.billStatus)
                        v.billStatusText = status.text
                        v.billStatusColor = JSON.parse(status.remark).color
                        v.billStatusBgc = JSON.parse(status.remark).background
                        if (v.feeType != '6' && v.feeType != '12') {
                            v.periodText = `第${v.period}期(${v.startDate}-${v.endDate})`
                        }
                        const planDate = new Date(v.planDate)
                        const nowDate = new Date(ymd(new Date()))
                        if (planDate < nowDate) {
                            v.overdue =
                                (nowDate - planDate) / (1000 * 60 * 60 * 24)
                        } else {
                            v.overdue = 0
                        }
                    })
                    this.setPageData(view.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        // 导出Excel
        onClickExport() {
            this.$refs.mt.exportToExcel()
        },
        // 账单详情
        rowClickInfo(row) {
            this.actionType = '2'
            this.curId = row.id
            this.depositOffset = row.depositOffset
            this.offsetAmount = row.offsetAmount
            this.billStatus = row.billStatus
            this.modal.showBillForm = true
        },
        rowClickRecord(row) {
            this.rowId = row.id
            this.modal.showBillRecord = true
        },
        // 筛选更改-账单状态
        changeFilterBillStatus(val) {
            switch (val) {
                case '1':
                    this.filter.billStatus = val
                    this.filter.overdue = '0'
                    break
                case '3':
                    this.filter.billStatus = val
                    this.filter.overdue = '0'
                    break
                case '6':
                    this.filter.billStatus = '1'
                    this.filter.overdue = '1'
                    break
                case '7':
                    this.filter.billStatus = '3'
                    this.filter.overdue = '1'
                    break
                default:
                    this.filter.overdue = ''
                    this.filter.billStatus = val
                    break
            }
            this.search()
        },
        // 根据是否逾期，初始化账单状态
        initBillStatus() {
            switch (this.filter.overdue) {
                case '0':
                    this.filterBillStatus = this.filter.billStatus
                    break
                case '1':
                    this.filterBillStatus =
                        this.filter.billStatus === '1' ? '6' : '7'
                    break
                default:
                    this.filterBillStatus = ''
                    break
            }
        },
    },
}
</script>
<style lang="less" scoped></style>
